
const KAKAO_LINK = 'https://pf.kakao.com/_xgsPfn/friend';

export default function KakaoFloatingButton() {
  return (
    <a
      href={KAKAO_LINK}
      target="_blank"
      rel="noopener noreferrer nofollow"
      aria-label="카카오톡 상담"
      title="카카오톡 상담"
      className="fixed bottom-8 right-8 z-50 w-14 h-14 flex items-center justify-center rounded-full bg-[#FEE500] shadow-lg hover:shadow-xl hover:scale-105 transition-all cursor-pointer group"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 256 256"
        className="w-8 h-8"
      >
        <path
          fill="#3C1E1E"
          d="M128 36C70.562 36 24 72.713 24 118c0 29.279 19.466 54.97 48.748 69.477l-10.202 37.34a4 4 0 0 0 6.178 4.2l43.645-29.163C117.408 200.614 122.637 201 128 201c57.438 0 104-36.713 104-83S185.438 36 128 36Z"
        />
      </svg>
      <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full border-2 border-[#FEE500] animate-pulse"></span>
    </a>
  );
}
